export const CheckGreen = 'rgb(50, 217, 78)'
export const XMarkRed = 'rgb(245, 24, 24)'
